export default {
  homeP: {
    home: "Home",
    about: "About Us",
    models: "Models",
    contact: "Contact us",
  },
  home: {
    lang: 'EN',
    // lang: '繁',
    lang_cn: 'Traditional Chinese',
    lang_en: 'English',
    submit: 'Submit',
    mandatory: 'Mandatory',
    yes: "Yes",
    no: "No",
    title1: 'Register now to stay updated with the latest information',
    lastName: 'Last name',
    firstName: 'First name',
    enterLastName: 'Please enter your last name',
    enterFirstName: 'Please enter your first name',
    emailAddress: 'Email address',
    enterEmail: 'Please enter your email',
    rightEmail: 'Please enter the correct email address!',
    mobileNumber: 'Mobile number',
    enterPhone: 'Please enter your phone number',
    rightPhone: 'Please enter the correct phone number!',
    privacyPolicy: "I/We agree with the use of my/our personal data by KLM,its affiliates, subsidiaries and associated companies for direct marketing purposes in accordance with the Personal Information Collection Statement and the Privacy Policy Statement.",
    appellation: 'Title',
    selectAppellation: 'Please select a title',
    corporateClient: 'Corporate client',
    selectLanguage: 'Select language',
    pleaseSelectLanguage: 'Please select language',
    InformationSubmitted: 'It has been submitted, thank you!',
    success: 'Success !',
    pleaseWriteName: 'company name',
    pleaseWriteName_: 'If so, please provide the company name',
    agree_: 'I/We have read and agree to the',
    statement_: 'Personal lnformation Collection Statement',
    policy_: 'Privacy Policy Statement',
    and: ' and ',
    corporateClient_: 'Please select a corporate customer',
    _policy: 'Please check “privacy policy”',
    remark: 'Remark',
    fullStop: '.',
    plan: 'I already own a private car and will participate in the "one-for-one" tax reduction scheme for the first registration of electric vehicles',
    news: 'News',
    exception: 'Network error, please submit again later!',
    pay: "Pay HK $1,000",
    loading: "Loading……",
    title6: "Hongqi's official general agent in Hong Kong - Kam Lung Motor Group",
    title6_2: "Represent all Hongqi car models (excluding taxis)",
    salesHotline:'Sales Hotline:',
    moreNews:'More News'

  },
  appellation: {
    Sir: 'Mr.',
    lady: 'Mrs.',
    Miss: 'Miss',
    PhD: 'Dr.',
    professor: 'professor',
  },
  carOption: {
    cartitle: 'Preferred model',
    car1: 'E-HS9',
    car2: 'E-QM5',
    carModel_: 'Please select your preferred model'
  },
  // history: {
  //   title: 'OUR HISTORY',
  //   history: "For over six decades, Hongqi has been a symbol of automotive excellence and a defining icon of China’s motoring heritage.From pioneering origins to its leadership in luxury craftsmanship, the marque has continually redefined prestige.Embracing modernity while honouring its distinctive spirit, Hongqi entered a new era in 2018 with a bold design philosophy and global vision — ushering the brand onto the world stage.",
  //   1958: "The first Hongqi car is crafted — the very first car produced independently in China.",
  //   1965: "The CA770 Hongqi three-row sedan is successfully trial-produced. Recognised as the “national car” and “the first car in China”, it became renowned both domestically and internationally for its use by state leaders and foreign guests. The model was mass- produced in the 1960s and 1970s in two subsidiary configurations: the CA770A and CA770B.",
  //   1969: "The first Hongqi security car is successfully trial-produced, in just three years. Pictured: the Hongqi CA772 bulletproof security car. ",
  //   1980: "Incorporating global advanced automobile technology, a series of new structures and innovations are adopted to reduce energy consumption, and improve power, comfort, and design. After five rounds of trial production, the CA774 model is completed to replace the CA770 sedan. ",
  //   1998: "The year marked the reveal of the flagship CA7460 luxury model, jointly designed by Hongqi and the United States’ Ford Motor Company. Showcasing the perfect combination of Oriental art and modern technology, the mass-produced CA7460 embodied a sense of intimacy and the charm of a new era.",
  //   2000: "The CA7202E3 second-generation sedan is officially put into mass production after a refreshed design and several rounds of trial production. Later on, in 2002, the CA7242E6 model with a 2.4L 5V engine is produced.",
  //   2013: "Representing the next wave of luxury executive sedans, the Hongqi H7 goes public.",
  //   2020: "Demonstrating its strong commitment to the future of sustainable mobility, Hongqi broke ground in April 2020 on a state-of-the-art new-energy vehicle (NEV) manufacturing facility in Changchun. Backed by a ¥7.6 billion (US$1.07 billion) investment, the plant is designed with an annual production capacity of 200,000 vehicles, reflecting Hongqi’s long-term vision to lead China’s premium electric vehicle landscape.",
  //   2024: "Hongqi’s annual sales volume reaches a record of 411,777, marking positive growth for seven consecutive years.",
  //   2025: "In a globalisation business press conference held at Auto Shanghai 2025, Hongqi unveiled a stunning lineup of new models, technologies, and its latest international development and global strategy, exhibiting its innovational ethos and future-forward vision. ",
  //   2026: "Kam Lung Motor Group launches Hongqi HK. Heralding a new era of luxury electric vehicles in this city-nation is the E-HS9, an all-electric smart SUV, with more premium models to follow. ",
  // },
  history: {
    title: 'Brand History',
    history: "For more than 60 years, Hongqi has been a symbol of exceptional automotive craftsmanship and a classic icon of Chinese automobile culture. From pioneering beginnings to the pursuit of luxury craftsmanship, the brand has continuously redefined the benchmark of high-end automobiles. Upholding its unique heritage and spirit of keeping pace with the times, Hongqi established a new design philosophy and global vision in 2018, entering a new stage of development and officially stepping onto the world stage.",
    1953: 'The Central Committee of the Communist Party of China issued the Instructions on Striving to Build the Changchun Automobile Factory in Three Years.',
    1958: 'Responding to the call of the Party Central Committee, FAW produced China\'s first homemade "Dongfeng" sedan by hand under extremely difficult conditions with a blank foundation. This was the predecessor of Hongqi sedans. After a test ride at the Huairen Hall in Zhongnanhai, Chairman Mao happily said: "Great! Finally, I\'m sitting in a car made by our own people!" Later, FAW put forward the slogan: "Ride the Dongfeng and unfurl the Hongqi, build premium sedans to meet Chairman Mao", and began the development of Hongqi premium sedans. On August 1, 1958, the first Hongqi premium sedan was produced, creating a miracle in China\'s automobile industry!',
    1960: 'The Hongqi CA72 premium sedan participated in the Leipzig International Trade Fair and was included in the World Car Yearbook in the same year.',
    1966: 'On the eve of May Day, the first batch of 20 Hongqi CA770 three-row premium sedans was delivered to Beijing, becoming the new generation of national ceremonial vehicles.',
    1978: 'China FAW invested the group\'s highest-quality resources in building Hongqi premium products, successfully developing two major vehicle series: L and H, laying a foundation for covering C, D, and E-class premium sedans.',
    2018: 'The first experience center of the New Hongqi opened. The annual sales volume of the Hongqi brand reached 30,000 units, completing the annual sales target 17 days ahead of schedule.',
    2019: 'Hongqi brand reached a strategic cooperation with the Palace Museum, integrating oriental aesthetics and modern innovation to jointly create a Chinese IP. Signed a strategic cooperation agreement with Xinhua News Agency to jointly build Hongqi into a world-class "Chinese automobile business card".',
    2020: 'Hongqi Brand Ceremony & Global Debut of H9 was held at the Great Hall of the People in Beijing. The National Glory High-end Private Salon was held in Beijing. At the event, FAW Hongqi signed a strategic cooperation agreement with the China Aerospace Foundation, officially becoming a "Strategic Partner of China\'s Aerospace Industry".',
    2022: 'The annual cumulative sales volume of the Hongqi brand reached 310,000 units.',
    2023: 'The National Glory High-end Private Salon was held in Beijing. At the event, FAW Hongqi signed a strategic cooperation agreement with the China Aerospace Foundation, officially becoming a "Strategic Partner of China\'s Aerospace Industry".',
    2026: "Kam Lung Motor Group has become the general agent of Hongqi in Hong Kong. ",
  },
  public: {
    history: 'history',
    explore: 'explore',
    learnMore: 'LEARN MORE',
    about: 'About hongqi',
    exploreH: 'EXPLORE hongqi',
    gallery: 'GALLERY',
    exterior: 'Exterior Details',
    Interior: 'Interior',
    highlights: 'MODEL Highlights',
    parameters: 'specifications',
    video: 'video',
    configuration: 'Parameter Configuration Table',
    note: 'note',
    standard: 'Standard configuration',
    standard1: 'Optional configuration',
    standard3: 'Not available',
    news: "In 2026, KamLung Automobile Group became the general agent of Hongqi in Hong Kong.",
    newsTitle: "Hongqi News",
    swipe: "Swipe left and right to view more car models | When scrolling up and down, the header remains fixed at the top.",
  },
  successPage: {
    congratulations: 'Congratulations! You have successfully made a reservation',
    unfinished: 'You have not completed the payment!',
    rePayment: 're-payment',
    error: 'Access parameter error!',
    confirm: 'confirm',
    cancel: 'cancel',
    Cancelled: 'You have canceled!',
    toHome: 'Are you sure you want to close and return to the information page?',
    rePay: 'Are you sure you want to re-pay the deposit?',
    wait1: 'Confirming payment result',
    wait: 'It is expected to be completed within 5 seconds. Please do not close the page',
  }
};

